import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/agent/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/agent/configuration/securityChanges/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from configuration
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Apply current theme
                    elements: [
                        {
                            view: 'label', // Label element for the title
                            label: _('Seguridad Cambios'), // Translated title
                            width: 150,
                        },
                    ],
                },
                Table, // Table component to display data
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Return the main configuration object for the view
        return {
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: true, // Enable scrolling
            cols: [left], // Columns layout with the left panel
        };
    }
}

// FILE DOCUMENTED
